import { gql } from 'graphql-request';

export default gql`query($filter: FilterInput) {
    lensAndCri(filter: $filter) {
        lenses {
            id
            name
            file_path
            application_group_name
            distribution_type
            lens_type_id
            led_module_category
            isoline_diagram_file_path
            no_photometric_file
        }
        cri {
			id
			name
			name_with_label
            mn_label
		}
        diode_ids
        typical_values {
			colorRenderingIndex
			colorTemperature
		}
        optic_types
        lens_application_groups
        led_module_categories
    }
}`;
